// Stars whose distance is still disputed: given as a range wherever Ahillah gives it (the star's card and the tour), as
// their spoken facts give it (data-src/facts/facts.json). The owner chose this for Deneb on 15 October 2026 (E4).

/** Light years, the nearer and the farther estimate. Deneb: its Hipparcos parallax (van Leeuwen 2007) puts it about
 *  1,400 light years away, the spectroscopic study of Schiller and Przybilla (2008, A&A 479, 849) about 2,600 (802 pc);
 *  Gaia has no parallax for it. */
export const DISTANCE_RANGE: Record<string, [number, number]> = { Deneb: [1400, 2600] };
